import {Component, ViewChild} from '@angular/core';
import {
  NavController, NavParams, Navbar, Loading,
  AlertController, LoadingController
} from 'ionic-angular';
import {PatientsPage} from "../patients/patients";
import {PatientService} from "../../providers/patient-service";
import {VisitsService} from "../../providers/visits.service";
import {VisitService} from "../../providers/visit.service";
import {VisitServiceService} from "../../providers/visit-service-service";
import {VisitPage} from "../visit/visit";

/*
 Generated class for the Visit page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-patient',
  templateUrl: 'patient.html'
})
export class PatientPage {

  visitPage: VisitPage;
  loading: Loading;
  createSuccess = false;
  patient_id: any;
  patient = {
    "id": null,
    "patient_name": "",
    "hospital_branch": null,
    "doctor": null,
    "payment_method": null
  };

  checked_in_text = "Check In";
  checked_in: boolean;

  current_visit = {
    "id": null,
    "patient": null,
    "happened_on": null
  }

  previous_visits = [];

  services = [
    {
      "id": 1,
      "name": "Consultation",
      "code": "C001",
      "max_price": "500.00",
      "min_price": "200.00"
    },
    {
      "id": 2,
      "name": "Adult Consultation",
      "code": "C002",
      "max_price": "550.00",
      "min_price": "300.00"
    },
    {
      "id": 3,
      "name": "Minor Surgery",
      "code": "C002",
      "max_price": "10000.00",
      "min_price": "5000.00"
    }
  ]

  procedures: Procedure[] = []

  visit_service = {visit: this.current_visit.id, procedure: '', charge: 0.00}

  @ViewChild(Navbar) navBar: Navbar;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private patientService: PatientService,
              private visitService: VisitService,
              private visitServiceService: VisitServiceService,
              private alertCtrl: AlertController,
              private loadingCtrl: LoadingController) {

    this.patient_id = navParams.get("patient_id");
    this.checked_in = false;
  }

  public addServiceToVisit() {
    this.showLoading();
    this.visitServiceService.addService(this.visit_service).subscribe(
      visit => {
        this.createSuccess = true;
        this.showPopup("Success", "Service added to visit")
      }, error => {
        let errors: string = "";
        for (var err in error.json()) {
          let field = err
          errors = errors + field + " " + error.json()[field] + "<br> "
        }
        this.showError(errors)
      }
    )
  }

  viewVisit(visit_id, happened_on){
    this.navCtrl.push(VisitPage, {
      visit_id:visit_id,
      happened_on:happened_on
    });
    //alert(visit_id)
  }

  closeVisit(){
    let patient_to_close = {id:this.patient.id, patient_name:this.patient.patient_name, status:0 }

    this.patientService.updatePatient(patient_to_close).subscribe(
      patient =>{
        this.navCtrl.popToRoot()
      }
    )
  }

  ngOnInit() {
    this.patientService.getPatient(this.patient_id).subscribe(
      patient => {
        this.patient = patient
      }, error => {
        let errors: string = "";
        for (var err in error.json()) {
          let field = err
          errors = errors + field + " " + error.json()[field] + "<br> "
        }
        this.showError(errors)
      }
    );

    this.visitService.checkVisitStatus(this.patient_id).subscribe(
      visit => {
        if (visit.length > 0) {
          this.current_visit = visit[0]
          this.checked_in_text = "Checked In";
          this.checked_in = true;

          //Update the current visit_service to take the new id
          this.visit_service.visit = this.current_visit.id

          //We add the services associated with this visit

          this.visitServiceService.getVisitServices(this.current_visit.id)
            .subscribe(services => {
                this.procedures = services
              }
            )
        }
      }
    );

    this.visitService.getPatientsVisits(this.patient_id).subscribe(
      visits =>{
        this.previous_visits = visits
      }
    )


  }

  createVisit() {
    this.showLoading();
    if (this.current_visit.id == null) {
      this.checked_in_text = "Checking in..."
      this.visitService.addVisit({patient: this.patient.id}).subscribe(
        visit => {
          this.current_visit = visit[0]
          this.checked_in_text = "Checked In";
          this.checked_in = true;
          this.loading.dismiss()
          this.navCtrl.push(PatientPage, {patient_id:this.patient_id});
        }, error => {
          let errors: string = "";
          for (var err in error.json()) {
            let field = err
            errors = errors + field + " " + error.json()[field] + "<br> "
          }
          this.showError(errors)
        }
      )
    } else {
      this.loading.dismiss();
    }

  }

  ionViewDidLoad() {
    this.navBar.backButtonClick = (e: UIEvent) => {
      // todo something
      this.navCtrl.push(PatientsPage);
    }

  }

  showPopup(title, text) {
    setTimeout(() => {
      this.loading.dismiss();
    })

    let alert = this.alertCtrl.create({
      title: title,
      subTitle: text,
      buttons: [
        {
          text: 'OK',
          handler: data => {
            if (this.createSuccess) {
              this.visitServiceService.getVisitServices(this.current_visit.id)
                .subscribe(services => {
                    this.procedures = services
                  }
                )
            }
          }
        }
      ]
    });
    alert.present(prompt);
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }


  showError(text) {
    setTimeout(() => {
      this.loading.dismiss();
    })

    let alert = this.alertCtrl.create({
      title: 'Failed',
      subTitle: text,
      buttons: ['OK']
    });

    alert.present(prompt)
  }


}

interface Procedure {
  procedure: any,
  charge: any,
  visit: any
}



// WEBPACK FOOTER //
// ./src/pages/patient/patient.ts